import script from "./DownloadView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadView.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadView.vue?vue&type=style&index=0&id=1022b4a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1022b4a7"]])

export default __exports__